export default __webpack_public_path__ + "static/media/qrTop2.20d3fda8.jpg";